// This is a generated file. Manual changes will be overwritten.

import React from "react";
import PropTypes from "prop-types";

export function IconDoubleEagle({ className, size, color }) {
  const s = size || "1em";

  const attr = { version: "1.1", viewBox: "0 0 32 32" };

  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      {...attr}
      className={className}
      style={{ color }}
      height={s}
      width={s}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M28.422 14.674c-0.439 0.338-1.052 0.839-1.87 1.139 1.55-1.203 3.417-3.567 2.883-5.348-2.555 3.976-7.11 7.099-12.1 7.58v0c-0.386-0.213-0.845-0.339-1.334-0.341h-0.001c-0.488 0.001-0.947 0.128-1.344 0.35l0.014-0.007c-4.992-0.48-9.55-3.608-12.105-7.58-0.534 1.775 1.333 4.149 2.883 5.347-0.809-0.301-1.431-0.801-1.87-1.139 0.589 1.678 1.76 2.507 2.751 2.824-1.1-0.338-2.049-0.747-2.943-1.242l0.078 0.040c0.383 1.819 3.157 3.006 5.091 3.316-0.2 0.016-0.434 0.026-0.669 0.026-0.536 0-1.062-0.048-1.571-0.14l0.053 0.008c1.321 1.191 2.745 1.353 3.734 1.138-0.449 0.149-0.983 0.273-1.533 0.349l-0.049 0.006c0.842 0.69 2.36 0.335 3.221-0.15-0.254 0.252-0.543 0.468-0.861 0.64l-0.020 0.010c0.962 0.111 1.574-0.268 1.852-0.645 0.24 0.148 0.516 0.271 0.809 0.355l0.024 0.006c-0.919 1.018-2.015 1.855-3.244 2.467l-0.063 0.029c1.236 0.266 2.856-0.719 3.672-1.529-0.208 0.378-0.465 0.701-0.768 0.974l-0.003 0.003c1.154-0.317 1.718-0.929 1.929-1.445-0.227 0.574-0.499 1.070-0.823 1.525l0.015-0.021c0.752-0.128 1.353-0.706 1.741-1.366 0.392 0.66 0.983 1.239 1.742 1.365-0.311-0.431-0.582-0.923-0.792-1.446l-0.017-0.047c0.21 0.516 0.774 1.127 1.93 1.445-0.306-0.276-0.564-0.599-0.763-0.958l-0.010-0.019c0.815 0.81 2.438 1.795 3.674 1.53-1.305-0.647-2.412-1.495-3.328-2.518l-0.009-0.010c0.344-0.101 0.635-0.213 0.914-0.345l-0.038 0.016c0.262 0.377 0.873 0.752 1.835 0.645-0.337-0.181-0.627-0.397-0.881-0.649l0 0c0.861 0.478 2.38 0.833 3.221 0.15-0.598-0.082-1.133-0.206-1.647-0.373l0.066 0.019c0.989 0.221 2.405 0.053 3.734-1.138-0.456 0.084-0.982 0.132-1.518 0.132-0.235 0-0.469-0.009-0.7-0.027l0.030 0.002c1.933-0.311 4.708-1.503 5.091-3.316-0.816 0.456-1.765 0.864-2.757 1.174l-0.108 0.029c0.992-0.326 2.162-1.156 2.751-2.833zM16 17.84c0.433 0.015 0.841 0.108 1.214 0.267l-0.022-0.008-0.458 1.55-0.433 0.358 0.15-0.492 0.189-0.161v-0.15l-0.277 0.236-0.018 0.029-0.346 1.115-0.341-1.112-0.018-0.029-0.278-0.236v0.159l0.192 0.15 0.161 0.525-0.012-0.032-0.433-0.359-0.451-1.55c0.333-0.164 0.725-0.26 1.14-0.26 0.014 0 0.028 0 0.042 0l-0.002-0z" />
      <path d="M12.183 8.241l0.888 2.754 2.894-0.006-2.343 1.696 0.897 2.751-2.336-1.706-2.339 1.706 0.9-2.751-2.345-1.696 2.895 0.006 0.888-2.754z" />
      <path d="M19.818 8.241l0.888 2.754 2.894-0.006-2.343 1.696 0.897 2.751-2.336-1.706-2.339 1.706 0.9-2.751-2.345-1.696 2.895 0.006 0.888-2.754z" />
    </svg>
  );
}

IconDoubleEagle.propTypes = {
  /**
   * Size in pixels (or a string with the size in CSS units)
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * A CSS color string.
   */
  color: PropTypes.string,
};
